import React, { useEffect, useState } from 'react';
import D3Funnel from 'd3-funnel';
import randomColor from 'randomcolor';
import { Col, Row } from 'reactstrap';
import { ColorArea } from './assets/styleds';
import useWindowSize from 'hooks/useWindowSize';
import { useHistory } from 'react-router-dom';

const options = {
  block: {
    dynamicHeight: true,
    minHeight: 25,
    fill: {
      type: 'gradient'
    }
  },
  label: {
    fill: '#fff'
  },
  chart: {
    curve: {
      enabled: true
    }
  }
};

const OpportunityFunnelGraphic = ({ data, total, formValues }) => {
  const [colors, setColors] = useState([]);
  const [funnelInfo, setFunnelInfo] = useState(null);
  const windowChange = useWindowSize();
  const history = useHistory();

  useEffect(() => {
    if (!funnelInfo) return;

    const chart = new D3Funnel('#funnel');
    chart.draw(funnelInfo, options);

    const funnelPaths = document.querySelectorAll('#funnel path');
    funnelPaths.forEach((path, index) => {
      if (index === 0) return;

      path.style.transition = 'fill 0.2s, opacity 0.2s';

      const handleMouseOver = () => {
        path.style.cursor = 'pointer';
        funnelPaths.forEach((otherPath, otherIndex) => {
          if (otherIndex !== index) {
            otherPath.style.opacity = '0.10';
          }
        });
        path.style.opacity = '1';
      };

      const handleMouseOut = () => {
        funnelPaths.forEach((otherPath) => {
          otherPath.style.opacity = '1';
        });
      };

      const handleClick = () => {
        const phaseId = funnelInfo[index - 1][3];
        history.push({
          pathname: '/admin/crm/opportunity',
          state: { phaseId, ...formValues }
        });
      };

      path.addEventListener('mouseover', handleMouseOver);
      path.addEventListener('mouseout', handleMouseOut);
      path.addEventListener('click', handleClick);

      return () => {
        path.removeEventListener('mouseover', handleMouseOver);
        path.removeEventListener('mouseout', handleMouseOut);
        path.removeEventListener('click', handleClick);
      };
    });
  }, [windowChange, funnelInfo, formValues, history]);

  useEffect(() => {
    const funnelData = data.map((row) => {
      const color = randomColor();
      setColors((prevColors) => [...prevColors, color]);
      return [row.name, row.quantity, color, row.id];
    });

    setFunnelInfo(funnelData);
  }, [data]);

  return (
    <>
      <Row className="mr-0">
        <Col sm="4">
          <div id="funnel" />
        </Col>

        <Col sm="8" className="mt-4">
          <Row>
            {data.map((item, i) => {
              return (
                <Col
                  key={item.name}
                  md="2"
                  className="mt--3 mb--3"
                  style={{
                    minHeight: '130px',
                    minWidth: 'fit-content',
                    maxWidth: 'fit-content'
                  }}
                >
                  <Row
                    className="row flex-nowrap"
                    style={{
                      minHeight: '100px'
                    }}
                  >
                    <Col md="1">
                      <ColorArea color={colors[i]} />
                    </Col>
                    <Col>
                      <h2 style={{ textWrap: 'nowrap' }}>
                        {item?.amount ?? 0}
                      </h2>
                      <h3
                        style={{ textWrap: 'nowrap' }}
                        className="text-muted font-weight-light mt--3"
                      >
                        {item.name}
                      </h3>
                      <h2
                        className="mt--1 font-weight-light"
                        style={{
                          paddingBottom: '1.5625rem'
                        }}
                      >
                        {item.percentage ? item.percentage + '%' : '0%'}
                      </h2>
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OpportunityFunnelGraphic;
